import { ToolError } from '@procureai/uix/ai';
import { ReactNode } from 'react';

export type ChatToolErrorIndicatorProps = {
  message: string;
};

export const ChatToolErrorIndicator = ({ message }: ChatToolErrorIndicatorProps): ReactNode => {
  return <ToolError label={message} />;
};
